// extracted by mini-css-extract-plugin
export default {"MobileAppBottomBarContainer":"MobileAppBottomBar_MobileAppBottomBarContainer__BytDc","MobileAppBottomBarMenu":"MobileAppBottomBar_MobileAppBottomBarMenu__gr-lr"};